import styled from 'styled-components'

export const ContentScrollTo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    cursor: pointer;
    max-width: 100%;
  }
`
